/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./notfound.component";
var styles_SystemNotFoundComponent = [];
var RenderType_SystemNotFoundComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_SystemNotFoundComponent, data: {} });
export { RenderType_SystemNotFoundComponent as RenderType_SystemNotFoundComponent };
export function View_SystemNotFoundComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_SystemNotFoundComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ng-component", [], null, null, null, View_SystemNotFoundComponent_0, RenderType_SystemNotFoundComponent)), i0.ɵdid(1, 114688, null, 0, i1.SystemNotFoundComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SystemNotFoundComponentNgFactory = i0.ɵccf("ng-component", i1.SystemNotFoundComponent, View_SystemNotFoundComponent_Host_0, {}, {}, []);
export { SystemNotFoundComponentNgFactory as SystemNotFoundComponentNgFactory };
